<template>
  <div id="layout">
    <Layout style="background:rgba(0,0,0,0);">
      <!--顶部提示组件-->
      <!--<TopTip ></TopTip>-->
      <!--顶部组件-->
      <HeadBar></HeadBar>
      <Layout id="layout-body">
        <!--左侧菜单-->
        <Sider  id="layout-slide-nav"  ref="side1" breakpoint="md" hide-trigger collapsible :collapsed-width="69" v-model="isCollapsed" width="300">
          <vue-scroll >
            <SlideBar style="background:rgba(0,0,0,0);" v-bind:menuitemClasses="menuitemClasses"></SlideBar>
          </vue-scroll>
        </Sider>
        <Layout :class="[!isCollapsed ? 'slide-right2' : '','layout-right-content']">
          <Content id="breads">
            <Row type="flex" justify="space-between">
              <Col>
                <Row type="flex">
                  <!--<Col>-->
                    <!--&lt;!&ndash;菜单显示/隐藏按钮&ndash;&gt;-->
                    <!--<Button @click.native="collapsedSider" class="nav-switch" type="text" style=" color: #2EF1F3;">-->
                      <!--<Icon style="position:relative;top:-1px"  :class="rotateIcon" size="20" type="ios-menu"></Icon>-->
                    <!--</Button>-->
                  <!--</Col>-->
                  <Col>
                    <!--面包屑-->
                    <BreadBar :breadCrumbList="breadCrumbList" ></BreadBar>
                  </Col>
                </Row>
              </Col>
              <Col class="tf-breads-right-func">
                <!--功能按钮-->
                <FuncBar style="margin-right: 15px;margin-top: 15px" ></FuncBar>
              </Col>
            </Row>
          </Content>
          <Content class="layout-content">
            <!--<div v-for="(vo,index) in user" :key="index">{{index}}：{{vo.emac}}</div>-->
            <router-view></router-view>
          </Content>
        </Layout>
      </Layout>
    </Layout>
    <!--声音-->
    <audio ref="myaudio" style="display: none" :src="sound"></audio>
  </div>
</template>

<script>
import { TopTip, HeadBar, SlideBar, BreadBar, FuncBar } from "./components";
import sound from "@/assets/img/1.mp3";

export default {
  components: {
    TopTip,
    HeadBar,
    SlideBar,
    BreadBar,
    FuncBar
  },
  data() {
    return {
      isCollapsed: false,
      sound:sound,
      user:[],
      obj:''
    };
  },
  computed: {
    // 当前面包屑数组
    breadCrumbList () {
      return this.$store.state.app.breadCrumbList
    },
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
    //接收socket消息
    wsMessage() {
      return this.$store.state.app.wsMessage;
    }
  },
  watch:{
    //监控并且格式化socket消息
    // wsMessage(e){
    //   const that = this;
    //   that.tipAudio();
    //   if(that.user.length > 0){
    //     that.user.map(function(vo,index){
    //       if(vo.emac == e.emac) {
    //         that.user.splice(index,1,e);
    //       }else{
    //         that.user.push(e);
    //       }
    //     })
    //   }else{
    //     that.user.push(e);
    //   }
    // }
  },
  created(){
    const that = this;
    if(that.$func.data.get('isCollapsed')){
      that.isCollapsed = that.$func.data.get('isCollapsed') == 'true' ? false : true;
    }
    that.$store.commit("updateUserInfo");
    that.$func.ys.getYsToken();
    //获取天正tokey
    that.$func.tz.getTokey();
  },
  mounted(){
    // const that = this;
    // setInterval(function () {
    //   that.websocketInit();
    // },5000)
  },
  methods: {
    //提示音
    tipAudio(){
      if(this.$func.data.get('soundSwitch') == 'true'){
        this.$refs.myaudio.play();
      }
    },
    collapsedSider() {
      this.$func.data.set('isCollapsed',this.isCollapsed)
      this.$refs.side1.toggleCollapse();
    },
    //初始化websocket
    websocketInit(){
      // const that = this;
      // that.$store.commit('setWsMessage',Math.random());
      // that.$func.tz.checkEquipment(function(res)
      // {
      //   if(JSON.stringify(res) != that.obj){
      //     that.obj = JSON.stringify(res);
      //     res.map(function (vo,index) {
      //         that.$store.commit('setWsMessage',vo);
      //     })
      //   }
      // })
      // that.$ws.init(that.$func.data.get('tzuid'),that.$func.data.get('tztokey'),'',function (e) {
      //   that.$store.commit('setWsMessage',e);
      // });
    }
  }
};
</script>

<style scoped>
</style>
